module.exports = __webpack_public_path__ + "img/hertford_b2.be702495.jpg";